import React, {PropTypes} from 'react';

const Maintenance = ({
  maintenanceMessage,
  onMaintenanceComplete
}) => (
  <div>
    <div className="alert alert-info text-center">
      {maintenanceMessage ? maintenanceMessage : onMaintenanceComplete(maintenanceMessage)}
    </div>
  </div>
);

Maintenance.propTypes = {
  maintenanceMessage: PropTypes.string,
  onMaintenanceComplete: PropTypes.func
};

export default Maintenance;



// WEBPACK FOOTER //
// ./src/features/shared/auth/Maintenance.jsx